import tw from 'tailwind-styled-components'

export const CloseModalTextContainer = tw.div`
    text-center
    py-6
`
